<template>
  <div :class="'toggle_wrap '+width">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <toggle
      v-model="
        // eslint-disable-next-line vue/no-mutating-props
        modelValue
      "
      class="toggle_custom"
      :disabled="disabled"
      @change="updateValue()"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import Toggle from '@vueform/toggle'

export default {
  components: {
    Toggle
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    bgColorOn: {
      type: String,
      required: false,
      default: '#5F2EEA'
    },
    bgColorOff: {
      type: String,
      required: false,
      default: '#D6D8E7'
    }
  },
  emits: ['update:modelValue'],
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', this.modelValue);
    },
  }
};
</script>
<style src="@vueform/toggle/themes/default.css"></style>

<style scoped>
.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.toggle_wrap {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.toggle_wrap .label {
  margin-bottom: 0;
}

.label {
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.toggle_custom {
  --toggle-bg-on: #37B2A8;
  --toggle-border-on: #37B2A8;
}

.toggle-container:focus {
  box-shadow: none;
}
</style>
